import 'es6-promise/auto'

import Vue from 'vue'
import { store } from './store/store';

import './assets/src/scss/main.scss'

import 'sweetalert/dist/sweetalert.css'
import swal from 'sweetalert'


import svg4everybody from './assets/js/svg4everybody.min.js'
svg4everybody({
    polyfill: true
});


import vuexI18n from 'vuex-i18n';
// helper functions for components (i.e. this.$i18n.set, this.$t) and on the vue
// instance (i.e. Vue.i18n.set).
Vue.use(vuexI18n.plugin, store);

import English from './store/lang/English.json';
import German from './store/lang/German.json';
import French from './store/lang/French.json';
import Chinese from './store/lang/Chinese.json';
import Indian from './store/lang/Indian.json';
import Italian from './store/lang/Italian.json';
import Spanish from './store/lang/Spanish.json';
import Portugese from './store/lang/Portugese.json';
import Dutch from './store/lang/Dutch.json';
import Russian from './store/lang/Russian.json';

// add translations directly to the application
Vue.i18n.add('English', English);
Vue.i18n.add('German', German);
Vue.i18n.add('French', French);
Vue.i18n.add('Chinese', Chinese);
Vue.i18n.add('Indian', Indian);
Vue.i18n.add('Italian', Italian);
Vue.i18n.add('Spanish', Spanish);
Vue.i18n.add('Portugese', Portugese);
Vue.i18n.add('Dutch', Dutch);
Vue.i18n.add('Russian', Russian);

// set the start locale to use
Vue.i18n.set('English');

import App from './App.vue'

import VueCordova from 'vue-cordova'
Vue.use(VueCordova);


// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
	window.isCordovaApp = true;
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

import _ from 'lodash'
//filter round to 2 decimals
Vue.filter('Rounder', function (num) {
  return +(Math.round(num + "e+2")  + "e-2"); //parseFloat(num).toFixed(1); //_.round(num, 3);
});

Vue.filter('RounderOut', function (num) {
  return _.round(num, 2);//+(Math.round(num + "e+2")  + "e-2"); //parseFloat(num).toFixed(1); //_.round(num, 3);
});




//images
//import './assets/img/icons/favicon.ico' from webpack HtmlWebpackPlugin
import './assets/img/icons/apple-touch-icon.png'
import './assets/img/icons/favicon-32x32.png'
import './assets/img/icons/favicon-16x16.png'
import './assets/img/icons/safari-pinned-tab.svg'
import './assets/img/svg_sprite/svg_sprite.svg'

var root = new Vue({
  el: '#app',
  store: store,
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js